import { z } from "zod";

import { ESubscriberSignatureStatus } from "@/types/backoffice/dto/signature/signature-details-dto.ts";
import { ESignatureEnvelopeType } from "@/types/backoffice/dto/site/site-installation-flow-dto.ts";

export const escPreinterventionEstimationResponseDtoSchema = z.object({
  alive: z.boolean(),
  creationDatetime: z.string().datetime(),
  type: z.nativeEnum(ESignatureEnvelopeType),
  id: z.number(),
  idSubSite: z.object({ id: z.number() }),
  idSubSubscriber: z.object({ id: z.number() }),
  info: z.string(),
  relatedDocumentsUploadDateTime: z.string().datetime().nullable(),
  signatureDate: z.string().datetime().nullable(),
  signatureLink: z.string(),
  signatureRequestId: z.string(),
  status: z.nativeEnum(ESubscriberSignatureStatus),
});

export type TESCPreinterventionEstimationResponseDto = z.infer<typeof escPreinterventionEstimationResponseDtoSchema>;
